import { SwipeRow } from "@/components/site/SwipeRow";
import { useSiteMedia } from "@/lib/site";

const KEYS = ["story-equipo", "story-estudio", "story-cuidado"];
const POS = { "story-equipo": "50% 45%", "story-estudio": "50% 50%", "story-cuidado": "50% 55%" };

export const StoryGallery = ({ testId = "story-gallery" }) => {
  const media = useSiteMedia();
  const items = KEYS.map((k) => media[k] || { key: k });
  return (
    <SwipeRow testId={testId} label="Galería de nuestra historia" items={items} getKey={(m) => m.key}
      render={(m) => (
        <figure className="m-0" data-testid={`${testId}-${m.key}`}>
          <div className="aspect-[4/3] overflow-hidden rounded-xl bg-[#EAE7E2]">
            {m.url && <img src={m.url} alt={m.alt} loading="lazy" className="h-full w-full object-cover" style={{ objectPosition: POS[m.key] }} />}
          </div>
          <figcaption className="mt-4 text-center font-serif-display text-xl sm:text-2xl">{m.title}</figcaption>
        </figure>
      )} />
  );
};
